// const BaseUrl = "http://localhost:3050/api";
const BaseUrl = "https://xpverse.herokuapp.com/api";

// internships
export const getAllInternshipsRoute = `${BaseUrl}/internships/get-all`;
export const exploreInternshipRoute = `${BaseUrl}/explore/get-all`;

// internship details
export const getInternshipDetailsRoute = `${BaseUrl}/internship-details/get`;

// auth
export const registerRoute = `${BaseUrl}/auth/register`;
export const loginRoute = `${BaseUrl}/auth/login`;
export const forgotPasswordRoute = `${BaseUrl}/auth/generate-otp`;
export const verifyOtpRoute = `${BaseUrl}/auth/verify-otp`;
export const resetPasswordRoute = `${BaseUrl}/auth/reset-password`;
export const verifySessionRoute = `${BaseUrl}/auth/verify-user-token`;

// profile
export const imageUploadRoute = `${BaseUrl}/storage/upload-image`;
export const getProfileRoute = `${BaseUrl}/auth/get-profile`;
export const updateProfileRoute = `${BaseUrl}/auth/update-profile`;

// user query
export const saveQueryRoute = `${BaseUrl}/query/save`;

// payments
export const createOrderIdRoute = `${BaseUrl}/payments/create/orderId`;
export const verifyPaymentRoute = `${BaseUrl}/payments/verify`;

// enroll
export const enrollInternshipRoute = `${BaseUrl}/enrolled-internship/enroll`;
export const getEnrolledInternshipRoute = `${BaseUrl}/enrolled-internship/get`;
export const submitWorkRoute = `${BaseUrl}/enrolled-internship/update`;
